export const AppTitle = (newTitle) => {
    return (document.title = newTitle);
  };